<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import { ddlHelper, sessionHelper } from "@/utils";
import { SESSION, MODULE } from "@/constants";
import { required } from "vuelidate/lib/validators";
import { mapState } from "vuex";
import i18n from "@/i18n";
import { AI_MODULE } from '@/state/modules/activeIngredient'
import { BRAND_MODULE } from '@/state/modules/brand'
import { CATEGORY_MODULE } from '@/state/modules/category'
import { CLASS_MODULE } from '@/state/modules/class'
import { FORM_MODULE } from '@/state/modules/form'
import { MOA_MODULE } from '@/state/modules/moa'
import { PRINTER_PFOOF_MODULE } from '@/state/modules/printerProofStatus'
import { PURPOSE_MODULE } from '@/state/modules/purpose'
import { QUERY_STATUS_MODULE } from '@/state/modules/queryStatus'
import { REGISTRATION_STATUS_MODULE } from '@/state/modules/registrationStatus'
import { RISK_STATUS_MODULE } from '@/state/modules/riskStatus'
import { SOURCE_MODULE } from '@/state/modules/source'
import { STATUS_MODULE } from '@/state/modules/status'
import { TYPE_MODULE } from '@/state/modules/type'
import { aiMethods, brandMethods, categoryMethods, classMethods, formMethods, moaMthods, printerProofMethods, purposeMethods, queryStatusMethods, registrationStatusMethods, riskStatusMethods, sourceMethods, statusMethods, typeMethods } from "@/state/helpers";
import Swal from "sweetalert2";

export default {
    page: {
        title: i18n.t("label.updateFormX", []),
    },
    components: { Layout, PageHeader },
    beforeRouteLeave(to, from, next) {
        if (this.$route.query.module == MODULE.AI && (to.name != "AI-listing" && to.name != "AI-update")) {
            sessionHelper.clearSearch(SESSION.ACTIVE_INGREDIENT_SEARCH);
        }
        else if (this.$route.query.module == MODULE.BRAND && (to.name != "Brand-listing" && to.name != "Brand-update")) {
            sessionHelper.clearSearch(SESSION.BRAND_SEARCH);
        }
        else if (this.$route.query.module == MODULE.CATEGORY && (to.name != "Category-listing" && to.name != "Category-update")) {
            sessionHelper.clearSearch(SESSION.CATEGORY_SEARCH);
        }
        else if (this.$route.query.module == MODULE.CLASS && (to.name != "Class-listing" && to.name != "Class-update")) {
            sessionHelper.clearSearch(SESSION.CLASS_SEARCH);
        }
        else if (this.$route.query.module == MODULE.FORM && (to.name != "Form-listing" && to.name != "Form-update")) {
            sessionHelper.clearSearch(SESSION.FORM_SEARCH);
        }
        else if (this.$route.query.module == MODULE.MOA && (to.name != "MOA-listing" && to.name != "MOA-update")) {
            sessionHelper.clearSearch(SESSION.MOA_SEARCH);
        }
        else if (this.$route.query.module == MODULE.PRINTER_PROOF && (to.name != "Printer-proof-listing" && to.name != "Printer-proof-update")) {
            sessionHelper.clearSearch(SESSION.PRINTER_PROOF_SEARCH);
        }
        else if (this.$route.query.module == MODULE.PURPOSE && (to.name != "Purpose-listing" && to.name != "Purpose-update")) {
            sessionHelper.clearSearch(SESSION.PURPOSE_SEARCH);
        }
        else if (this.$route.query.module == MODULE.QUERY_STATUS && (to.name != "Query-status-listing" && to.name != "Query-status-update")) {
            sessionHelper.clearSearch(SESSION.QUERY_STATUS_SEARCH);
        }
        else if (this.$route.query.module == MODULE.REGISTARTION_STATUS && (to.name != "Registration-status-listing" && to.name != "Registration-status-update")) {
            sessionHelper.clearSearch(SESSION.REGISTRATION_STATUS_SEARCH);
        }
        else if (this.$route.query.module == MODULE.RISK_STATUS && (to.name != "Risk-status-listing" && to.name != "Risk-status-update")) {
            sessionHelper.clearSearch(SESSION.RISK_STATUS_SEARCH);
        }
        else if (this.$route.query.module == MODULE.SOURCE && (to.name != "Source-listing" && to.name != "Source-update")) {
            sessionHelper.clearSearch(SESSION.SOURCE_SEARCH);
        }
        else if (this.$route.query.module == MODULE.STATUS && (to.name != "Status-listing" && to.name != "Status-update")) {
            sessionHelper.clearSearch(SESSION.STATUS_SEARCH);
        }
        else if (this.$route.query.module == MODULE.TYPE && (to.name != "Type-listing" && to.name != "Type-update")) {
            sessionHelper.clearSearch(SESSION.TYPE_SEARCH);
        }
        next();
    },
    computed: {
        ...mapState(AI_MODULE, ["status"]),
        ...mapState(BRAND_MODULE, ["status"]),
        ...mapState(CATEGORY_MODULE, ["status"]),
        ...mapState(CLASS_MODULE, ["status"]),
        ...mapState(FORM_MODULE, ["status"]),
        ...mapState(MOA_MODULE, ["status"]),
        ...mapState(PRINTER_PFOOF_MODULE, ["status"]),
        ...mapState(PURPOSE_MODULE, ["status"]),
        ...mapState(QUERY_STATUS_MODULE, ["status"]),
        ...mapState(REGISTRATION_STATUS_MODULE, ["status"]),
        ...mapState(RISK_STATUS_MODULE, ["status"]),
        ...mapState(SOURCE_MODULE, ["status"]),
        ...mapState(STATUS_MODULE, ["status"]),
        ...mapState(TYPE_MODULE, ["status"]),
        titleData() {
            return this.titleText;
        },
        itemData() {
            return this.items;
        },
        data() {
            return this.details;
        },
    },
    data() {
        return {
            titleText: '',
            title: this.titleText,
            items: [],
            submitted: false,
            details: null,
            statusDdl: ddlHelper.getActivationStatus(false, true),
            permissions: sessionHelper.getPermissions(),
            updatePermission: null,
            readPermission: null,
        };
    },
    validations: {
        data: {
            name: { required },
        },
    },
    created() {
        var jsonPermissions = JSON.parse(this.permissions)

        if (this.$route.query.module == MODULE.AI) {
            this.titleText = i18n.t("label.updateX", [i18n.t("module.activeIngredient")])
            this.items = [
                {
                    text: i18n.t("module.dashboard"),
                    href: "/",
                },
                {
                    text: i18n.t("module.activeIngredient"),
                    href: "/AI",
                },
                {
                    text: i18n.t("label.updateX", [i18n.t("module.activeIngredient")]),
                    active: true,
                },
            ];

            if (jsonPermissions.some(p => p.code === "RND_AI_AIU")) {
                this.updatePermission = true;
            }
            else {
                this.updatePermission = false;
            }

            if (jsonPermissions.some(p => p.code === "RND_AI_AIR")) {
                this.readPermission = true;
            }
            else {
                this.readPermission = false;
            }

            if (this.readPermission == true) {
                this.searchCriteria = sessionHelper.retrieveSearch(SESSION.ACTIVE_INGREDIENT_SEARCH);
                this.getDetails();
            }
        }
        else if (this.$route.query.module == MODULE.BRAND) {
            this.titleText = i18n.t("label.updateX", [i18n.t("module.brand")])
            this.items = [
                {
                    text: i18n.t("module.dashboard"),
                    href: "/",
                },
                {
                    text: i18n.t("module.brand"),
                    href: "/bran",
                },
                {
                    text: i18n.t("label.updateX", [i18n.t("module.brand")]),
                    active: true,
                },
            ];

            if (jsonPermissions.some(p => p.code === "RND_BRAND_BU")) {
                this.updatePermission = true;
            }
            else {
                this.updatePermission = false;
            }

            if (jsonPermissions.some(p => p.code === "RND_BRAND_BR")) {
                this.readPermission = true;
            }
            else {
                this.readPermission = false;
            }

            if (this.readPermission == true) {
                this.searchCriteria = sessionHelper.retrieveSearch(SESSION.BRAND_SEARCH);
                this.getDetails();
            }
        }
        else if (this.$route.query.module == MODULE.CATEGORY) {
            this.titleText = i18n.t("label.updateX", [i18n.t("module.category")])
            this.items = [
                {
                    text: i18n.t("module.dashboard"),
                    href: "/",
                },
                {
                    text: i18n.t("module.category"),
                    href: "/category",
                },
                {
                    text: i18n.t("label.updateX", [i18n.t("module.category")]),
                    active: true,
                },
            ];

            if (jsonPermissions.some(p => p.code === "RND_CATEGORY_CU")) {
                this.updatePermission = true;
            }
            else {
                this.updatePermission = false;
            }

            if (jsonPermissions.some(p => p.code === "RND_CATEGORY_CR")) {
                this.readPermission = true;
            }
            else {
                this.readPermission = false;
            }

            if (this.readPermission == true) {
                this.searchCriteria = sessionHelper.retrieveSearch(SESSION.CATEGORY_SEARCH);
                this.getDetails();
            }
        }
        else if (this.$route.query.module == MODULE.CLASS) {
            this.titleText = i18n.t("label.updateX", [i18n.t("module.class")])
            this.items = [
                {
                    text: i18n.t("module.dashboard"),
                    href: "/",
                },
                {
                    text: i18n.t("module.class"),
                    href: "/class",
                },
                {
                    text: i18n.t("label.updateX", [i18n.t("module.class")]),
                    active: true,
                },
            ];

            if (jsonPermissions.some(p => p.code === "RND_CLASS_CLSU")) {
                this.updatePermission = true;
            }
            else {
                this.updatePermission = false;
            }

            if (jsonPermissions.some(p => p.code === "RND_CLASS_CLSR")) {
                this.readPermission = true;
            }
            else {
                this.readPermission = false;
            }

            if (this.readPermission == true) {
                this.searchCriteria = sessionHelper.retrieveSearch(SESSION.CLASS_SEARCH);
                this.getDetails();
            }
        }
        else if (this.$route.query.module == MODULE.FORM) {
            this.titleText = i18n.t("label.updateX", [i18n.t("module.form")])
            this.items = [
                {
                    text: i18n.t("module.dashboard"),
                    href: "/",
                },
                {
                    text: i18n.t("module.form"),
                    href: "/form",
                },
                {
                    text: i18n.t("label.updateX", [i18n.t("module.form")]),
                    active: true,
                },
            ];

            if (jsonPermissions.some(p => p.code === "RND_FORM_FU")) {
                this.updatePermission = true;
            }
            else {
                this.updatePermission = false;
            }

            if (jsonPermissions.some(p => p.code === "RND_FORM_FR")) {
                this.readPermission = true;
            }
            else {
                this.readPermission = false;
            }

            if (this.readPermission == true) {
                this.searchCriteria = sessionHelper.retrieveSearch(SESSION.FORM_SEARCH);
                this.getDetails();
            }
        }
        else if (this.$route.query.module == MODULE.MOA) {
            this.titleText = i18n.t("label.updateX", [i18n.t("module.moa")])
            this.items = [
                {
                    text: i18n.t("module.dashboard"),
                    href: "/",
                },
                {
                    text: i18n.t("module.moa"),
                    href: "/moa",
                },
                {
                    text: i18n.t("label.updateX", [i18n.t("module.moa")]),
                    active: true,
                },
            ];

            if (jsonPermissions.some(p => p.code === "RND_MOA_MOAU")) {
                this.updatePermission = true;
            }
            else {
                this.updatePermission = false;
            }

            if (jsonPermissions.some(p => p.code === "RND_MOA_MOAR")) {
                this.readPermission = true;
            }
            else {
                this.readPermission = false;
            }

            if (this.readPermission == true) {
                this.searchCriteria = sessionHelper.retrieveSearch(SESSION.MOA_SEARCH);
                this.getDetails();
            }
        }
        else if (this.$route.query.module == MODULE.PRINTER_PROOF) {
            this.titleText = i18n.t("label.updateX", [i18n.t("module.printerProof")])
            this.items = [
                {
                    text: i18n.t("module.dashboard"),
                    href: "/",
                },
                {
                    text: i18n.t("module.printerProof"),
                    href: "/printer-proof",
                },
                {
                    text: i18n.t("label.updateX", [i18n.t("module.printerProof")]),
                    active: true,
                },
            ];

            if (jsonPermissions.some(p => p.code === "RND_PP_PPU")) {
                this.updatePermission = true;
            }
            else {
                this.updatePermission = false;
            }

            if (jsonPermissions.some(p => p.code === "RND_PP_PPR")) {
                this.readPermission = true;
            }
            else {
                this.readPermission = false;
            }

            if (this.readPermission == true) {
                this.searchCriteria = sessionHelper.retrieveSearch(SESSION.PRINTER_PROOF_SEARCH);
                this.getDetails();
            }
        }
        else if (this.$route.query.module == MODULE.PURPOSE) {
            this.titleText = i18n.t("label.updateX", [i18n.t("module.purpose")])
            this.items = [
                {
                    text: i18n.t("module.dashboard"),
                    href: "/",
                },
                {
                    text: i18n.t("module.purpose"),
                    href: "/purpose",
                },
                {
                    text: i18n.t("label.updateX", [i18n.t("module.purpose")]),
                    active: true,
                },
            ];

            if (jsonPermissions.some(p => p.code === "RND_PURPOSE_PU")) {
                this.updatePermission = true;
            }
            else {
                this.updatePermission = false;
            }

            if (jsonPermissions.some(p => p.code === "RND_PURPOSE_PR")) {
                this.readPermission = true;
            }
            else {
                this.readPermission = false;
            }

            if (this.readPermission == true) {
                this.searchCriteria = sessionHelper.retrieveSearch(SESSION.PURPOSE_SEARCH);
                this.getDetails();
            }
        }
        else if (this.$route.query.module == MODULE.QUERY_STATUS) {
            this.titleText = i18n.t("label.updateX", [i18n.t("module.queryStatus")])
            this.items = [
                {
                    text: i18n.t("module.dashboard"),
                    href: "/",
                },
                {
                    text: i18n.t("module.queryStatus"),
                    href: "/query-status",
                },
                {
                    text: i18n.t("label.updateX", [i18n.t("module.queryStatus")]),
                    active: true,
                },
            ];

            if (jsonPermissions.some(p => p.code === "RND_QSTATUS_QSU")) {
                this.updatePermission = true;
            }
            else {
                this.updatePermission = false;
            }

            if (jsonPermissions.some(p => p.code === "RND_QSTATUS_QSR")) {
                this.readPermission = true;
            }
            else {
                this.readPermission = false;
            }

            if (this.readPermission == true) {
                this.searchCriteria = sessionHelper.retrieveSearch(SESSION.QUERY_STATUS_SEARCH);
                this.getDetails();
            }
        }
        else if (this.$route.query.module == MODULE.REGISTARTION_STATUS) {
            this.titleText = i18n.t("label.updateX", [i18n.t("module.registrationStatus")])
            this.items = [
                {
                    text: i18n.t("module.dashboard"),
                    href: "/",
                },
                {
                    text: i18n.t("module.registrationStatus"),
                    href: "/registration-status",
                },
                {
                    text: i18n.t("label.updateX", [i18n.t("module.registrationStatus")]),
                    active: true,
                },
            ];

            if (jsonPermissions.some(p => p.code === "RND_RSTSTATUS_RSTSU")) {
                this.updatePermission = true;
            }
            else {
                this.updatePermission = false;
            }

            if (jsonPermissions.some(p => p.code === "RND_RSTSTATUS_RSTSR")) {
                this.readPermission = true;
            }
            else {
                this.readPermission = false;
            }

            if (this.readPermission == true) {
                this.searchCriteria = sessionHelper.retrieveSearch(SESSION.REGISTRATION_STATUS_SEARCH);
                this.getDetails();
            }
        }
        else if (this.$route.query.module == MODULE.RISK_STATUS) {
            this.titleText = i18n.t("label.updateX", [i18n.t("module.riskStatus")])
            this.items = [
                {
                    text: i18n.t("module.dashboard"),
                    href: "/",
                },
                {
                    text: i18n.t("module.riskStatus"),
                    href: "/risk-status",
                },
                {
                    text: i18n.t("label.updateX", [i18n.t("module.riskStatus")]),
                    active: true,
                },
            ];

            if (jsonPermissions.some(p => p.code === "RND_RS_RSU")) {
                this.updatePermission = true;
            }
            else {
                this.updatePermission = false;
            }

            if (jsonPermissions.some(p => p.code === "RND_RS_RSR")) {
                this.readPermission = true;
            }
            else {
                this.readPermission = false;
            }

            if (this.readPermission == true) {
                this.searchCriteria = sessionHelper.retrieveSearch(SESSION.RISK_STATUS_SEARCH);
                this.getDetails();
            }
        }
        else if (this.$route.query.module == MODULE.SOURCE) {
            this.titleText = i18n.t("label.updateX", [i18n.t("module.source")])
            this.items = [
                {
                    text: i18n.t("module.dashboard"),
                    href: "/",
                },
                {
                    text: i18n.t("module.source"),
                    href: "/source",
                },
                {
                    text: i18n.t("label.updateX", [i18n.t("module.source")]),
                    active: true,
                },
            ];

            if (jsonPermissions.some(p => p.code === "RND_SOURCE_SU")) {
                this.updatePermission = true;
            }
            else {
                this.updatePermission = false;
            }

            if (jsonPermissions.some(p => p.code === "RND_SOURCE_SR")) {
                this.readPermission = true;
            }
            else {
                this.readPermission = false;
            }

            if (this.readPermission == true) {
                this.searchCriteria = sessionHelper.retrieveSearch(SESSION.SOURCE_SEARCH);
                this.getDetails();
            }
        }
        else if (this.$route.query.module == MODULE.STATUS) {
            this.titleText = i18n.t("label.updateX", [i18n.t("module.status")])
            this.items = [
                {
                    text: i18n.t("module.dashboard"),
                    href: "/",
                },
                {
                    text: i18n.t("module.status"),
                    href: "/status",
                },
                {
                    text: i18n.t("label.updateX", [i18n.t("module.status")]),
                    active: true,
                },
            ];

            if (jsonPermissions.some(p => p.code === "RND_STATUS_SU")) {
                this.updatePermission = true;
            }
            else {
                this.updatePermission = false;
            }

            if (jsonPermissions.some(p => p.code === "RND_STATUS_SR")) {
                this.readPermission = true;
            }
            else {
                this.readPermission = false;
            }

            if (this.readPermission == true) {
                this.searchCriteria = sessionHelper.retrieveSearch(SESSION.STATUS_SEARCH);
                this.getDetails();
            }
        }
        else if (this.$route.query.module == MODULE.TYPE) {
            this.titleText = i18n.t("label.updateX", [i18n.t("module.type")])
            this.items = [
                {
                    text: i18n.t("module.dashboard"),
                    href: "/",
                },
                {
                    text: i18n.t("module.type"),
                    href: "/type",
                },
                {
                    text: i18n.t("label.updateX", [i18n.t("module.type")]),
                    active: true,
                },
            ];

            if (jsonPermissions.some(p => p.code === "RND_TYPE_TU")) {
                this.updatePermission = true;
            }
            else {
                this.updatePermission = false;
            }

            if (jsonPermissions.some(p => p.code === "RND_TYPE_TR")) {
                this.readPermission = true;
            }
            else {
                this.readPermission = false;
            }

            if (this.readPermission == true) {
                this.searchCriteria = sessionHelper.retrieveSearch(SESSION.TYPE_SEARCH);
                this.getDetails();
            }
        }
        else {
            const swalWithBootstrapButtons = Swal.mixin({
                customClass: {
                    confirmButton: "btn btn-primary",
                },
                buttonsStyling: false
            });

            swalWithBootstrapButtons
                .fire({
                    title: i18n.t('message.invalidX', [i18n.t('label.moduleX', [])]),
                    text: i18n.t('message.invalidDataPleaseContactAdmin'),
                    icon: "error",
                    confirmButtonText: "OK",
                })
                .then(result => {
                    if (result.value) {
                        this.$router.go(-1);
                    }
                });
        }
    },
    methods: {
        ...aiMethods,
        ...brandMethods,
        ...categoryMethods,
        ...classMethods,
        ...formMethods,
        ...moaMthods,
        ...printerProofMethods,
        ...purposeMethods,
        ...queryStatusMethods,
        ...registrationStatusMethods,
        ...riskStatusMethods,
        ...sourceMethods,
        ...statusMethods,
        ...typeMethods,
        async getDetails() {
            if (this.$route.query.module == MODULE.AI) {
                await this.getAI({ id: this.searchCriteria.selectedRecordId });
                this.details = this.$store.state.activeIngredient.details;
            }
            else if (this.$route.query.module == MODULE.BRAND) {
                await this.getBrand({ id: this.searchCriteria.selectedRecordId });
                this.details = this.$store.state.brand.details;
            }
            else if (this.$route.query.module == MODULE.CATEGORY) {
                await this.getCategory({ id: this.searchCriteria.selectedRecordId });
                this.details = this.$store.state.category.details;
            }
            else if (this.$route.query.module == MODULE.CLASS) {
                await this.getClass({ id: this.searchCriteria.selectedRecordId });
                this.details = this.$store.state.class.details;
            }
            else if (this.$route.query.module == MODULE.FORM) {
                await this.getForm({ id: this.searchCriteria.selectedRecordId });
                this.details = this.$store.state.form.details;
            }
            else if (this.$route.query.module == MODULE.MOA) {
                await this.getMOA({ id: this.searchCriteria.selectedRecordId });
                this.details = this.$store.state.moa.details;
            }
            else if (this.$route.query.module == MODULE.PRINTER_PROOF) {
                await this.getPrinterProof({ id: this.searchCriteria.selectedRecordId });
                this.details = this.$store.state.printerProofStatus.details;
            }
            else if (this.$route.query.module == MODULE.PURPOSE) {
                await this.getPurpose({ id: this.searchCriteria.selectedRecordId });
                this.details = this.$store.state.purpose.details;
            }
            else if (this.$route.query.module == MODULE.QUERY_STATUS) {
                await this.getQuery({ id: this.searchCriteria.selectedRecordId });
                this.details = this.$store.state.queryStatus.details;
            }
            else if (this.$route.query.module == MODULE.REGISTARTION_STATUS) {
                await this.getRegistration({ id: this.searchCriteria.selectedRecordId });
                this.details = this.$store.state.registrationStatus.details;
            }
            else if (this.$route.query.module == MODULE.RISK_STATUS) {
                await this.getRisk({ id: this.searchCriteria.selectedRecordId });
                this.details = this.$store.state.riskStatus.details;
            }
            else if (this.$route.query.module == MODULE.SOURCE) {
                await this.getSource({ id: this.searchCriteria.selectedRecordId });
                this.details = this.$store.state.source.details;
            }
            else if (this.$route.query.module == MODULE.STATUS) {
                await this.getStatus({ id: this.searchCriteria.selectedRecordId });
                this.details = this.$store.state.status.details;
            }
            else if (this.$route.query.module == MODULE.TYPE) {
                await this.getType({ id: this.searchCriteria.selectedRecordId });
                this.details = this.$store.state.type.details;
            }
        },
        requestUpdate() {
            this.submitted = true;
            // stop here if form is invalid
            this.$v.$touch();

            if (this.$v.$invalid) {
                return;
            } else {
                let data = {
                    id: this.data.uuid,
                    name: this.data.name,
                };

                if (this.updatePermission == true) {
                    if (this.$route.query.module == MODULE.AI) {
                        this.updateAI({ data });
                    }
                    else if (this.$route.query.module == MODULE.BRAND) {
                        this.updateBrand({ data });
                    }
                    else if (this.$route.query.module == MODULE.CATEGORY) {
                        this.updateCategory({ data });
                    }
                    else if (this.$route.query.module == MODULE.CLASS) {
                        this.updateClass({ data });
                    }
                    else if (this.$route.query.module == MODULE.FORM) {
                        this.updateForm({ data });
                    }
                    else if (this.$route.query.module == MODULE.MOA) {
                        this.updateMOA({ data });
                    }
                    else if (this.$route.query.module == MODULE.PRINTER_PROOF) {
                        this.updatePrinterProof({ data });
                    }
                    else if (this.$route.query.module == MODULE.PURPOSE) {
                        this.updatePurpose({ data });
                    }
                    else if (this.$route.query.module == MODULE.QUERY_STATUS) {
                        this.updateQuery({ data });
                    }
                    else if (this.$route.query.module == MODULE.REGISTARTION_STATUS) {
                        this.updateRegistration({ data });
                    }
                    else if (this.$route.query.module == MODULE.RISK_STATUS) {
                        this.updateRisk({ data });
                    }
                    else if (this.$route.query.module == MODULE.SOURCE) {
                        this.updateSource({ data });
                    }
                    else if (this.$route.query.module == MODULE.STATUS) {
                        this.updateStatus({ data });
                    }
                    else if (this.$route.query.module == MODULE.TYPE) {
                        this.updateType({ data });
                    }
                }

            }
        },
    },
};
</script>

<template>
    <Layout>
        <PageHeader :title="titleData" :items="itemData" />
        <div class="row">
            <div class="col">
                <div class="card">
                    <div class="card-body">
                        <form @submit.prevent="requestUpdate" v-if="readPermission == true">
                            <b-form-group id="name" label-cols-sm="2" label-cols-lg="2" :label="$t('label.name')"
                                label-for="name">
                                <b-form-input for="name" v-model.trim="data.name"
                                    :class="{ 'is-invalid': !$v.data.name.required }"></b-form-input>
                                <div v-if="!$v.data.name.required" class="invalid-feedback">
                                    <span v-if="!$v.data.name.required">{{
                                        $t("message.requiredX", [$t("label.name")])
                                        }}</span>
                                </div>
                            </b-form-group>

                            <div class="mt-4 text-center" style="float: right">
                                <button class="btn btn-primary w-md waves-effect waves-light" style="margin-right: 10px"
                                    type="submit" :disabled="status.update || updatePermission != true">
                                    {{ this.titleData }}
                                </button>
                            </div>
                        </form>
                        <div style="text-align: center;" v-else>
                            {{ $t('message.noPermissionMessage') }}
                        </div>
                    </div>
                </div>
                <!-- end card -->
            </div>
            <!-- end col -->
        </div>
    </Layout>
</template>